import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { Observable, Observer } from 'rxjs';

import { ModalDirective } from 'ngx-bootstrap/modal';

export interface IGridFieldsPickerField {
  fieldName: string;
  displayName: string;
  isSelected: boolean;
  order?: number;
}

export interface IGridFieldsPickerState {
  dynamicFields: Array<IGridFieldsPickerField>;
}

const byOrder = (left: IGridFieldsPickerField, right: IGridFieldsPickerField) => left.order - right.order;

@Component({
  selector: 'app-grid-fields-picker',
  templateUrl: './grid-fields-picker.component.html',
  styleUrls: ['./grid-fields-picker.component.scss'],
})
export class GridFieldsPickerComponent implements OnInit {
  @ViewChild('fieldsPickerModal', { static: true }) public fieldsPickerModal: ModalDirective;

  @Input() getState: () => Observable<IGridFieldsPickerState>;
  @Input() saveState: (state: IGridFieldsPickerState) => void;
  @Input() resetState: () => Observable<IGridFieldsPickerState>;

  resultObserver: Observer<IGridFieldsPickerState>;

  busy = false;

  model = {
    selectedFields: new Array<IGridFieldsPickerField>(),
    availableFields: new Array<IGridFieldsPickerField>(),
  };

  ngOnInit() {}

  open(): Observable<IGridFieldsPickerState> {
    this.getState().subscribe((state) => {
      this.model = this.createModel(state);
    });

    this.fieldsPickerModal.show();
    return new Observable((observer) => (this.resultObserver = observer));
  }

  toggleField(field: IGridFieldsPickerField) {
    if (field.isSelected) {
      field.isSelected = false;
      this.model.selectedFields = this.model.selectedFields.filter((x) => x.fieldName !== field.fieldName);
      this.model.availableFields = [...this.model.availableFields, field];
    } else {
      field.isSelected = true;
      this.model.selectedFields = [...this.model.selectedFields, field];
      this.model.availableFields = this.model.availableFields.filter((x) => x.fieldName !== field.fieldName);
    }
  }

  hasSelectedFields(): boolean {
    return this.model.selectedFields.length > 0;
  }

  submit() {
    if (!this.hasSelectedFields()) {
      return;
    }

    this.model.selectedFields.forEach((field, idx) => {
      field.order = idx;
    });

    let result = { dynamicFields: this.model.selectedFields };

    this.saveState(result);
    this.resultObserver.next(result);
    this.resultObserver.complete();
    this.fieldsPickerModal.hide();
  }

  reset() {
    this.resetState().subscribe((state) => {
      this.model = this.createModel(state);
    });
  }

  cancel() {
    this.resultObserver.next(null);
    this.resultObserver.complete();
    this.fieldsPickerModal.hide();
  }

  private createModel(state: IGridFieldsPickerState): { selectedFields: Array<IGridFieldsPickerField>; availableFields: Array<IGridFieldsPickerField> } {
    return {
      selectedFields: state.dynamicFields.filter((x) => x.isSelected).sort(byOrder),
      availableFields: state.dynamicFields.filter((x) => !x.isSelected),
    };
  }
}
